function Hotspot(id, selector, d){

    var self = this;

    self.id = selector+ id;

    self.$hotspot = $( ".hotspot" , self.id);
    self.$hover = $( ".hover" , self.id);
    self.$more = $( ".more" , self.id);
    self.$top = $( ".top" , self.id);
    self.$bottom = $( ".bottom" , self.id);

    //self.width = self.$hotspot.width();
    //self.height = self.$hotspot.height();

   //console.log("w "+ self.width + " h "+ self.height);

    self.mouseover=false;
    self.timeout =0;

    //TweenMax.set(self.$hover, {width:self.width, height: self.height, scaleX: 1, scaleY: 1});
    //TweenMax.set(self.$top, {left: -d});
    //TweenMax.set(self.$bottom, {right: -d});

    function sizeHotspot(){

        self.width = self.$hotspot.width();
        self.height = self.$hotspot.height();

        TweenMax.set(self.$hover, {width:self.width, height: self.height, scaleX: 1, scaleY: 1});
        TweenMax.set(self.$top, {left: -d});
        TweenMax.set(self.$bottom, {right: -d});

    }

    sizeHotspot();

    $(window).resize(function () {

        sizeHotspot();
    });

    if(!Modernizr.touch){

        //console.log("not touch");

        self.$hotspot.mouseover(function() {

            clearTimeout(self.timeout);

            //self.animsKill();
            TweenMax.to(self.$more, 0.1, {autoAlpha: 1});
            TweenMax.to(self.$hover, 0.2, {autoAlpha: 0.95, scaleX: 1.2, scaleY: 1.2});
            TweenMax.to(self.$top, 0.2, {left: 0, delay:0.2});
            TweenMax.to(self.$bottom, 0.2, {right: 0, delay:0.2});


        });

        self.$hotspot.mouseout(function() {

           //self.animsKill();

            clearTimeout(self.timeout);

            self.timeout = setTimeout(function () {

                TweenMax.to(self.$more, 0.1, {autoAlpha: 0});
                TweenMax.to(self.$top, 0.2, {left: -d});
                TweenMax.to(self.$bottom, 0.2, {right: -d});
                TweenMax.to(self.$hover, 0.25, {autoAlpha: 0, scaleX: 1, scaleY: 1, delay:0.1});


            }, 100);


        });

        self.$more.mouseover(function() {

           // clearTimeout(self.timeout);

            console.log("more over");

            TweenMax.to(self.$top, 0.15, {top: -5});
            TweenMax.to(self.$bottom, 0.15, {bottom: -5});


        });
        self.$more.mouseout(function() {

           // clearTimeout(self.timeout);

            console.log("more out");

            TweenMax.to(self.$top, 0.15, {top: 0});
            TweenMax.to(self.$bottom, 0.15, {bottom: 0});


        });
    } else {

        TweenMax.set(self.$hotspot, {AutoAlpha: 0});
        TweenMax.set(self.$hover, {AutoAlpha: 0});
    }




}
Hotspot.prototype.animsKill = function () {

    var self = this;

    TweenMax.killTweensOf(self.$top);
    TweenMax.killTweensOf(self.$bottom);
    TweenMax.killTweensOf(self.$hover);


};

Hotspot.prototype.resize = function () {


};



